// Single source of truth for every language list in the app.
export const SUPPORTED_LANGUAGES = [
  { code: 'fr', name: 'Français' },
  { code: 'en', name: 'English' },
  { code: 'es', name: 'Español' },
  { code: 'de', name: 'Deutsch' },
  { code: 'it', name: 'Italiano' },
  { code: 'pt', name: 'Português' },
  { code: 'nl', name: 'Nederlands' },
  { code: 'ru', name: 'Русский' },
  { code: 'zh', name: '中文' },
  { code: 'ar', name: 'العربية' },
] as const;

export type LanguageCode = (typeof SUPPORTED_LANGUAGES)[number]['code'];

export const SOURCE_LANGUAGE: LanguageCode = 'fr';

export const LANGUAGE_CODES = SUPPORTED_LANGUAGES.map((l) => l.code) as string[];

export const isSupportedLanguage = (code: string | null | undefined): code is LanguageCode =>
  !!code && LANGUAGE_CODES.includes(code);

export const getLanguageName = (code: string) =>
  SUPPORTED_LANGUAGES.find((l) => l.code === code)?.name ?? code;
